import * as Sentry from '@sentry/react';

const sentryOnceCache = new Set<string>();

export const reportOnceToSentry = (
  key: string,
  message: string,
  level: Sentry.SeverityLevel = 'info'
) => {
  if (sentryOnceCache.has(key)) return;

  Sentry.captureMessage(message, level);
  sentryOnceCache.add(key);
};
